import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { collection, getDocs, query } from "firebase/firestore";
import db from "../../firebase";

const BidsSection = () => {
  const loggedUser = useSelector((state) => state.loggedUser);
  const [bids, setBids] = useState();

  useEffect(() => {
    const getBids = async () =>
      await getDocs(
        query(collection(db, `user_data/${loggedUser.uid}/images`))
      ).then((bidsData) => {
        const data = bidsData.docs.map((bidData) => bidData.data());
        setBids(data.length > 0 ? data : null);
      });
    getBids();
  }, []);

  const dateFormat = (date) =>
    date.toDate().toLocaleDateString("en-IN").replaceAll("/", "-");

  const timeFormat = (time) => time.toDate().toLocaleTimeString("en-IN");

  return bids && bids.length > 0 ? (
    <table className="table m-0">
      <thead>
        <tr className="text-white">
          <th>Date</th>
          <th>Time</th>
          <th>Image Id</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        {bids.map((item, index) => (
          <tr key={index} className="text-white">
            <td>{dateFormat(item.time)}</td>
            <td>{timeFormat(item.time)}</td>
            <td>{item.imageId}</td>
            <td>${item.amount}</td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : bids === null ? (
    <div className="text-center text-white py-4">No Transactions Found!</div>
  ) : (
    <div className="text-center py-4">
      <div className="spinner-border text-light" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default BidsSection;
